import React from "react";

export default function Copyright() {
  return (
    <div className="text-center py-9 text-white">
      <p className="text-sm md:text-xl font-semibold">Copyright © 2022 | All Rights Reserved</p>
    </div>
  );
}
